import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { TriggerScanType } from '@terra/shared-contracts-external-network';
import { terraProxyApiClient } from '../../clients/testerClient';
import { EXTERNAL_NETWORK_STATS_KEY } from './useExternalNetworkStats';
import { EXTERNAL_NETWORK_SCANS_KEY } from './useExternalNetworkScans';

export function useTriggerExternalNetworkScan() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      surfaceId,
      scanType,
    }: {
      surfaceId: string;
      scanType: TriggerScanType;
    }) => {
      return terraProxyApiClient.triggerExternalNetworkScan({
        surfaceId,
        scanType,
      });
    },
    onSuccess: async (_data, { surfaceId }) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [EXTERNAL_NETWORK_SCANS_KEY, surfaceId],
        }),
        queryClient.invalidateQueries({
          queryKey: [EXTERNAL_NETWORK_STATS_KEY, surfaceId],
        }),
      ]);
    },
  });
}

export function useStopExternalNetworkScan() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      surfaceId,
      scanId,
    }: {
      surfaceId: string;
      scanId: string;
    }) => {
      return terraProxyApiClient.stopExternalNetworkScan({
        surfaceId,
        scanId,
      });
    },
    onSuccess: async (_data, { surfaceId }) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [EXTERNAL_NETWORK_SCANS_KEY, surfaceId],
        }),
        queryClient.invalidateQueries({
          queryKey: [EXTERNAL_NETWORK_STATS_KEY, surfaceId],
        }),
      ]);
    },
  });
}
